import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FooterCTA() {
  return <footer className="w-full px-6 py-20 bg-brown text-cream text-center" data-id="element-12">
      <div className="max-w-reading mx-auto" data-id="element-13">
        <h2 className="text-2xl md:text-3xl font-serif mb-6 leading-tight" data-id="element-14">
          Si te cansaste de sostenerlo todo en tu cabeza, este es tu siguiente
          paso:
        </h2>

        <p className="text-cream/80 mb-10 text-lg font-light" data-id="element-15">
          Compra "Bebé Sin Derrumbe" y en 14 días instala un sistema simple para
          repartir propiedad — sin apps, sin rogar y sin repetir la misma
          conversación.
        </p>

        <a href="#pricing" className="inline-flex items-center justify-center gap-2 bg-ochre hover:bg-white hover:text-brown text-white text-lg font-medium py-4 px-8 rounded-full w-full md:w-auto transition-all shadow-lg shadow-black/20 group" data-id="element-16">
          Quiero mi kit — US$7.39
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-17" />
        </a>

        <div className="mt-16 pt-8 border-t border-white/10 text-xs text-white/40" data-id="element-18">
          <p data-id="element-19">
            © {new Date().getFullYear()} Bebé Sin Derrumbe. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}